import { Components, Theme } from '@mui/material';

const placeholderColor = (theme: Theme) =>
  (theme.palette as { placeholder?: string }).placeholder ??
  theme.palette.text.secondary;

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    input: ({ theme }: { theme: Theme }) => {
      const color = placeholderColor(theme);
      return {
        '&::placeholder': {
          color,
          opacity: 1,
        },
        '&::-webkit-input-placeholder': {
          color,
          opacity: 1,
        },
        '&::-moz-placeholder': {
          color,
          opacity: 1,
        },
      };
    },
  },
};
